/**
 * Minimal CSV download helper. Values are exported RAW (numbers as numbers,
 * no $ formatting) so the file drops straight into Excel / Sheets formulas.
 * A UTF-8 BOM is prepended so Excel detects the encoding.
 */
export interface CsvColumn { label: string; get: (r: any) => any; }

export function downloadCsv(filename: string, rows: any[], columns: CsvColumn[]): void {
  const esc = (v: any): string => {
    const s = v == null ? "" : String(v);
    return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const lines = [columns.map(c => esc(c.label)).join(",")];
  for (const r of rows) lines.push(columns.map(c => esc(c.get(r))).join(","));
  const blob = new Blob(["\ufeff" + lines.join("\r\n")], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(url); }, 100);
}
